<!--  -->
<template>
  <div class="traffic-main">
    <div id="todayUsePowerChart" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      todayUsePowerChart: null,
      todayUsePowerChartOption: {},
      xData: [],
      yAxisData1: [],
    };
  },

  mounted() {
    var self = this;

    self.todayUsePowerChart = charts.init(
      document.getElementById("todayUsePowerChart")
    );
    self.queryData().then((res) => {
      self.initPowerChart();
    });
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.energy.queryEnergyRecordByDay).then((res) => {
          if (res.success) {
            res.returnObj.forEach((el) => {
              this.xData.push(el.date);
              this.yAxisData1.push(el.energyValue);
              // this.yData[1].push(el.personnelOutCount);
            });
            resolve({ xData: this.xData, yData: this.yAxisData1 });
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    initPowerChart() {
      const color = ["#02ECFF", "#E8395D"];
      const option = {
        color: color,
        // title: {
        //   text: "今日用电量",
        //   textStyle: {
        //     color: "#FFFFFF",
        //     fontSize: 15,
        //   },
        //   left: "40",
        //   top: "0",
        // },
        legend: {
          icon: "rect",
          itemHeight: 4,
          itemWidth: 10,
          textStyle: {
            color: "#ffffff",
          },
          right: 10,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 30,
          left: 10,
          bottom: 0,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            name: "时",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff",
              },
            },
            data: this.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：KWH",
            axisLabel: {
              show: true,
              width: "100",
              height: 12,
              fontSize: 14,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
              color: "#ffffff",
            },
            nameTextStyle: {
              color: "#ffffff",
              // align: "left",
              padding: [0, 0, 0, 50],
              // lineHeight: 40,
              // height: 12,
              fontSize: 12,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgb(10, 59, 119)",
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#1E2537",
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "用电量",
            type: "line",
            smooth: true,
            symbol: "none",

            symbolSize: 10,
            lineStyle: {
              normal: {
                color: color[0],
                width: 2,
              },
            },
            areaStyle: {
              color: new charts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(27, 235, 242, 0)",
                },
                {
                  offset: 1,
                  color: "#343740",
                },
              ]),
            },
            data: this.yAxisData1,
          },
          //   {
          //     name: "出园",
          //     type: "line",
          //     smooth: true,
          //     symbolSize: 10,
          //     lineStyle: {
          //       normal: {
          //         color: color[1],
          //         width: 2,
          //       },
          //     },
          //     data: yAxisData2,
          //   },
        ],
      };
      this.todayUsePowerChart = charts.init(
        document.getElementById("todayUsePowerChart")
      );
      this.todayUsePowerChart.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
.traffic-main {
  height: 100%;
}
</style>